import { Seo } from "../components/Seo";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { Gallery } from "../components/GalleryLightbox";
import { CtaBanner } from "../components/CtaBanner";
import { galleryImages, site } from "../config/siteConfig";

export default function GalleryPage() {
  return (
    <>
      <Seo
        title="Gallery | Ansar Public School Mundeke Goraya, Daska"
        description="View the gallery of Ansar Public School Mundeke — campus, classrooms, learning and activities. Real school photos are added as supplied."
      />
      <PageHero
        chapter="01"
        eyebrow="Gallery"
        title="Life at Our School"
        description="Browse by category and tap any photo to view it up close. Current images are licensed stock placeholders — authentic school photos will replace them once supplied."
        crumb="Gallery"
      />

      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:py-20" data-testid="gallery-section">
        <Reveal>
          <Gallery images={galleryImages} />
        </Reveal>
      </section>

      <section className="mx-auto max-w-7xl px-4 pb-16 sm:px-6 lg:pb-24">
        <CtaBanner
          idPrefix="gallery-admissions"
          title="Want to See the Campus in Person?"
          text="Families are welcome to visit. Call the school to plan your visit to the campus in Mundeke Goraya."
          primaryLabel="Start an Admission Enquiry"
          primaryTo="/admissions"
          secondaryLabel="Call the School"
          secondaryHref={site.phoneHref}
        />
      </section>
    </>
  );
}
